import { useEffect, useState } from "react";
import {
  useGetAllAddsPromosQuery,
  useUpdateAddsPromosMutation,
  useNewAddsPromosMutation,
} from "../slices/addsPromosApiSlice";
import {
  Button,
  ButtonGroup,
  Col,
  Form,
  FormCheck,
  Row,
} from "react-bootstrap";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import { toast } from "react-toastify";

const AddsPromos = () => {
  const [selectedAddPromo, setSelectedAddPromo] = useState(null);
  const [isFormDirty, setIsFormDirty] = useState(false);

  const [formData, setFormData] = useState({
    id: null,
    title: "",
    organisation: "",
    promo: false,
    code: "",
    paid: false,
    duration: 0,
    playDates: [
      {
        startDate: new Date(new Date().setHours(24, 0, 0, 0)),
        endDate: new Date(new Date().setHours(0, 0, 0, 0)).setDate(
          new Date().getDate() + 29
        ),
        Sunday: true,
        Monday: true,
        Tuesday: true,
        Wednesday: true,
        Thursday: true,
        Friday: true,
        Saturday: true,
        playTimes: [
          {
            startTime: 0,
            endTime: 1440,
            plays: 7,
          },
        ],
      },
    ],
  });

  const timeChoices = [
    { time: "Zero Hr", timeHour: 0 },
    { time: "1 am", timeHour: 60 },
    { time: "2 am", timeHour: 120 },
    { time: "3 am", timeHour: 180 },
    { time: "4 am", timeHour: 240 },
    { time: "5 am", timeHour: 300 },
    { time: "6 am", timeHour: 360 },
    { time: "7 am", timeHour: 420 },
    { time: "8 am", timeHour: 480 },
    { time: "9 am", timeHour: 540 },
    { time: "10 am", timeHour: 600 },
    { time: "11 am", timeHour: 660 },
    { time: "12 pm", timeHour: 720 },
    { time: "13 pm", timeHour: 780 },
    { time: "14 pm", timeHour: 840 },
    { time: "15 pm", timeHour: 900 },
    { time: "16 pm", timeHour: 960 },
    { time: "17 pm", timeHour: 1020 },
    { time: "18 pm", timeHour: 1080 },
    { time: "19 pm", timeHour: 1140 },
    { time: "20 pm", timeHour: 1200 },
    { time: "21 pm", timeHour: 1260 },
    { time: "22 pm", timeHour: 1320 },
    { time: "23 pm", timeHour: 1380 },
    { time: "Midnight", timeHour: 1440 },
  ];

  const {
    data: addsPromos,
    error: addsPromosError,
    isLoading: addsPromosLoading,
  } = useGetAllAddsPromosQuery();

  const [updateAddsPromos] = useUpdateAddsPromosMutation();
  const [newAddsPromos] = useNewAddsPromosMutation();

  const datePlayDates = (fromdate, todate, index) => {
    const playDates = [new Date(fromdate), new Date(todate)];
    return (
      <DateRangePicker
        onChange={(e) => handlePlayDateChange(e, index)}
        value={playDates}
        format="dd-MM-yyyy"
      />
    );
  };

  useEffect(() => {
    if (addsPromos) {
      if (selectedAddPromo === null) {
        setSelectedAddPromo(addsPromos[0]._id);
      }
    }
    // eslint-disable-next-line
  }, [addsPromos]);

  // useEffect(() => {
  //   if (formData) {
  //     console.log("formData:", formData);
  //   }
  //   // eslint-disable-next-line
  // }, [formData]);

  useEffect(() => {
    if (selectedAddPromo != null) {
      const selectedAddPromoData = addsPromos.find(
        (addPromo) => addPromo._id === selectedAddPromo
      );
      if (selectedAddPromoData !== undefined) {
        setFormData({
          ...formData,
          id: selectedAddPromo,
          organisation: selectedAddPromoData.organisation,
          promo: selectedAddPromoData.promo,
          title: selectedAddPromoData.title,
          code: selectedAddPromoData.code,
          paid: selectedAddPromoData.paid,
          duration: selectedAddPromoData.duration,
          playDates: selectedAddPromoData.playDates,
        });
      }
    }
    // eslint-disable-next-line
  }, [selectedAddPromo, addsPromos]);

  const handlePlayDateChange = (e, index) => {
    const startDate = new Date(e[0]).toISOString();
    const endDate = new Date(e[1]).toISOString();
    setFormData((prevData) => ({
      ...prevData,
      playDates: prevData.playDates.map((playDate, i) =>
        i === index
          ? { ...playDate, startDate: startDate, endDate: endDate }
          : playDate
      ),
    }));
    setIsFormDirty(true);
  };

  const handleFormChange = (e) => {
    e.preventDefault();

    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
    setIsFormDirty(true);
  };

  const handleCheckboxChange = (e) => {
    const { id, checked } = e.target;
    if (checked) {
      setFormData((prevData) => ({
        ...prevData,
        [id]: true,
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [id]: false,
      }));
    }
    setIsFormDirty(true);
  };

  const handlePlayDatesFormChange = (
    playDateindex,
    playtimeindex,
    field,
    value
  ) => {
    let newPlayDates = [...formData.playDates];
    let updatedObject = {
      ...newPlayDates[playDateindex],
      playTimes: newPlayDates[playDateindex].playTimes.map((playTime, i) =>
        i === playtimeindex ? { ...playTime, [field]: Number(value) } : playTime
      ),
    };
    newPlayDates[playDateindex] = updatedObject;
    setFormData({
      ...formData,
      playDates: newPlayDates,
    });
    setIsFormDirty(true);
  };

  const handlePlaysChange = (index, playTimesIndex, event) => {
    const newPlayDates = formData.playDates.map((playdate, i) => {
      if (i === index) {
        return {
          ...playdate,
          playTimes: playdate.playTimes.map((playtime, i) =>
            i === playTimesIndex
              ? { ...playtime, plays: parseInt(event.target.value) }
              : playtime
          ),
        };
      } else {
        return playdate;
      }
    });
    setFormData({ ...formData, playDates: newPlayDates });
    setIsFormDirty(true);
  };

  const handleAddTimeButtonClick = (event, index) => {
    event.preventDefault();
    setFormData((prevData) => ({
      ...prevData,
      playDates: prevData.playDates.map((playDate, i) =>
        i === index
          ? {
              ...playDate,
              playTimes: [
                ...playDate.playTimes,
                { startTime: 0, endTime: 1440, plays: 7 },
              ],
            }
          : playDate
      ),
    }));

    setIsFormDirty(true);
  };
  const handleAddDateButtonClick = (programId) => {
    const startDate = new Date();
    startDate.setHours(24, 0, 0, 0);

    const endDate = new Date(startDate);
    endDate.setDate(endDate.getDate() + 28);
    endDate.setHours(23, 59, 59, 999);

    setFormData((prevData) => ({
      ...prevData,
      playDates: [
        ...prevData.playDates,
        {
          startDate: startDate.toISOString(),
          endDate: endDate.toISOString(),
          Sunday: true,
          Monday: true,
          Tuesday: true,
          Wednesday: true,
          Thursday: true,
          Friday: true,
          Saturday: true,
          playTimes: [
            {
              startTime: 0,
              endTime: 1440,
              plays: 7,
            },
          ],
        },
      ],
    }));

    setIsFormDirty(true);
  };

  const handleNewAddPromo = (e) => {
    e.preventDefault();
    setFormData({
      id: null,
      title: "",
      organisation: "",
      promo: false,
      code: "",
      paid: false,
      duration: 0,
      playDates: [
        {
          startDate: new Date(new Date().setHours(24, 0, 0, 0)),
          endDate: new Date(new Date().setHours(0, 0, 0, 0)).setDate(
            new Date().getDate() + 29
          ),
          Sunday: true,
          Monday: true,
          Tuesday: true,
          Wednesday: true,
          Thursday: true,
          Friday: true,
          Saturday: true,
          playTimes: [
            {
              startTime: 0,
              endTime: 1440,
              plays: 7,
            },
          ],
        },
      ],
    });
    setIsFormDirty(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !formData.title ||
      !formData.organisation ||
      !formData.code ||
      !formData.duration ||
      !formData.playDates
    ) {
      toast.error("All fields are required. Document not saved.", {
        position: "bottom-center",
        autoClose: 2500,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "colored",
      });
      return;
    }
    if (formData.id !== null) {
      await updateAddsPromos(formData);
    } else {
      const newAddsPromosRes = await newAddsPromos(formData);
      setSelectedAddPromo(newAddsPromosRes.data._id);
    }
    setIsFormDirty(false);
  };

  const handleDayPlayChange = async (e, day) => {
    const index = Number(e.target.value);
    setFormData((prevData) => ({
      ...prevData,
      playDates: prevData.playDates.map((playDate, i) =>
        i === index
          ? {
              ...playDate,
              [day]: !playDate[day],
            }
          : playDate
      ),
    }));

    setIsFormDirty(true);
  };
  return (
    <Row className="mt-4">
      <Col
        xs="5"
        style={{ height: "1000px", overflowY: "scroll" }}
        className="p-2 border border-1"
      >
        {addsPromosError ? (
          <div>Error loading Adds and Promos</div>
        ) : addsPromosLoading ? (
          <div>Loading Adds and Promos...</div>
        ) : (
          <ButtonGroup
            vertical
            size="sm"
            className="col-12"
          >
            {addsPromos &&
              addsPromos.map((addPromo) => (
                <Button
                  key={addPromo._id}
                  variant={
                    selectedAddPromo === addPromo._id ? "primary" : "light"
                  }
                  onClick={() => {
                    setSelectedAddPromo(addPromo._id);
                    setIsFormDirty(false);
                  }}
                >
                  <Row>
                    <Col
                      className="text-start text-capitalize text-truncate"
                      xs="4"
                    >
                      {addPromo.title}
                    </Col>
                    <Col
                      className="text-start text-capitalize text-truncate"
                      xs="4"
                    >
                      {addPromo.organisation}
                    </Col>
                    <Col
                      className="text-start text-capitalize text-truncate"
                      xs="2"
                    >
                      {addPromo.promo ? (
                        <span>Promo</span>
                      ) : (
                        // addPromo.promo
                        <span>Add</span>
                      )}
                    </Col>
                    <Col
                      className="text-start text-capitalize text-truncate"
                      xs="2"
                    >
                      {addPromo.paid && <span>Paid</span>}
                    </Col>
                  </Row>
                </Button>
              ))}
          </ButtonGroup>
        )}
      </Col>
      <Col className="p-2 border border-1 border-start-0">
        <small>
          <Row>
            <Col>
              <Form onSubmit={handleSubmit}>
                <Row className="h4 border-bottom pb-3 ">
                  <Col className="text-center">Adds & Promos</Col>
                </Row>
                <Row className="pt-2 ">
                  <Col
                    sm={2}
                    className="align-self-center text-end"
                  >
                    Promo
                  </Col>
                  <Col
                  // xs={2}
                  // className="align-items-center"
                  >
                    <Row>
                      <Col xs={9}>
                        <Form.Check // prettier-ignore
                          type={"checkbox"}
                          isValid
                          id={"promo"}
                          checked={formData.promo ? true : false}
                          defaultValue={formData.promo}
                          onChange={handleCheckboxChange}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row className="align-items-center pt-2 ">
                  <Col
                    sm={2}
                    className="align-self-center text-end"
                  >
                    Organisation:
                  </Col>
                  <Col>
                    <Form.Group controlId="organisation">
                      <Form.Control
                        size="sm"
                        type="text"
                        placeholder="Enter Organisation"
                        value={formData.organisation}
                        onChange={handleFormChange}
                        maxLength={40}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col
                    sm={2}
                    className="align-self-center text-end"
                  >
                    Title:
                  </Col>
                  <Col>
                    <Form.Group controlId="title">
                      <Form.Control
                        size="sm"
                        type="text"
                        placeholder="Enter title"
                        value={formData.title}
                        onChange={handleFormChange}
                        maxLength={40}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="align-items-center pt-2 ">
                  <Col
                    sm={2}
                    className="align-self-center text-end"
                  >
                    Code:
                  </Col>
                  <Col>
                    {/* <Form.Group controlId="code"> */}
                    <Form.Control
                      id="code"
                      size="sm"
                      as="textarea"
                      type="text"
                      placeholder="Enter Code"
                      value={formData.code}
                      onChange={handleFormChange}
                      rows={3}
                    />
                    {/* </Form.Group> */}
                  </Col>
                </Row>
                <Row className="pt-2 align-items-center">
                  <Col
                    className="text-end  pt-2 "
                    xs={2}
                  >
                    Paid:
                  </Col>
                  <Col
                    xs={3}
                    className="align-items-center"
                  >
                    <Row>
                      <Col xs={9}>
                        <Form.Check // prettier-ignore
                          type={"checkbox"}
                          isValid
                          id={"paid"}
                          checked={formData.paid ? true : false}
                          defaultValue={formData.paid}
                          onChange={handleCheckboxChange}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row className="pt-2 align-items-center">
                  <Col
                    sm={2}
                    className="text-end pt-2 "
                  >
                    Length Secs:
                  </Col>
                  <Col
                    sm={3}
                    className="pt-2"
                  >
                    <Form.Group>
                      <Form.Control
                        id={"duration"}
                        size="sm"
                        type="text"
                        placeholder="Enter run time"
                        value={formData.duration}
                        onChange={handleFormChange}
                        maxLength={3}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="pt-2 mt-2">
                  <Col
                    className="text-end pt-2 "
                    xs={2}
                  >
                    Play Dates:
                  </Col>
                  <Col className="mx-2">
                    {/* Map through playdates */}
                    {formData.playDates.map((playdate, index) => (
                      <Row
                        key={index}
                        className="py-3 my-1 border border-danger-subtle"
                      >
                        <Col>
                          <Row>
                            <Col>
                              <Row>
                                <Col xs={5}>
                                  {datePlayDates(
                                    playdate.startDate,
                                    playdate.endDate,
                                    index
                                  )}
                                </Col>
                                <Col>
                                  <Row>
                                    <Col></Col>
                                    <Col className="text-center">S</Col>
                                    <Col className="text-center">M</Col>
                                    <Col className="text-center">T</Col>
                                    <Col className="text-center">W</Col>
                                    <Col className="text-center">T</Col>
                                    <Col className="text-center">F</Col>
                                    <Col className="text-center">S</Col>
                                    <Col></Col>
                                  </Row>
                                  <Row>
                                    <Col></Col>
                                    <Col className="text-center">
                                      <FormCheck
                                        type="checkbox"
                                        checked={playdate.Sunday ? true : false}
                                        onChange={(i) =>
                                          handleDayPlayChange(i, "Sunday")
                                        }
                                        value={index}
                                        isValid
                                      />
                                    </Col>
                                    <Col className="text-center">
                                      <FormCheck
                                        type="checkbox"
                                        checked={playdate.Monday ? true : false}
                                        onChange={(i) =>
                                          handleDayPlayChange(i, "Monday")
                                        }
                                        value={index}
                                        isValid
                                      />
                                    </Col>
                                    <Col className="text-center">
                                      <FormCheck
                                        type="checkbox"
                                        checked={
                                          playdate.Tuesday ? true : false
                                        }
                                        onChange={(i) =>
                                          handleDayPlayChange(i, "Tuesday")
                                        }
                                        value={index}
                                        isValid
                                      />
                                    </Col>
                                    <Col className="text-center">
                                      <FormCheck
                                        type="checkbox"
                                        checked={
                                          playdate.Wednesday ? true : false
                                        }
                                        onChange={(i) =>
                                          handleDayPlayChange(i, "Wednesday")
                                        }
                                        value={index}
                                        isValid
                                      />
                                    </Col>
                                    <Col className="text-center">
                                      <FormCheck
                                        type="checkbox"
                                        checked={
                                          playdate.Thursday ? true : false
                                        }
                                        onChange={(i) =>
                                          handleDayPlayChange(i, "Thursday")
                                        }
                                        value={index}
                                        isValid
                                      />
                                    </Col>
                                    <Col className="text-center">
                                      <FormCheck
                                        type="checkbox"
                                        checked={playdate.Friday ? true : false}
                                        onChange={(i) =>
                                          handleDayPlayChange(i, "Friday")
                                        }
                                        value={index}
                                        isValid
                                      />
                                    </Col>
                                    <Col className="text-center">
                                      <FormCheck
                                        type="checkbox"
                                        checked={
                                          playdate.Saturday ? true : false
                                        }
                                        onChange={(i) =>
                                          handleDayPlayChange(i, "Saturday")
                                        }
                                        value={index}
                                        isValid
                                      />
                                    </Col>
                                    <Col></Col>
                                  </Row>
                                </Col>
                              </Row>
                              {playdate.playTimes.map(
                                (playTimes, playTimesIndex) => (
                                  <Row
                                    key={playTimesIndex}
                                    className="mt-2"
                                  >
                                    <Col
                                      xs={1}
                                      className="pt-2"
                                    >
                                      Start:
                                    </Col>
                                    <Col>
                                      <Form.Group controlId="startTime">
                                        <Form.Control
                                          size="sm"
                                          as="select"
                                          value={playTimes.startTime}
                                          onChange={(e) =>
                                            handlePlayDatesFormChange(
                                              index,
                                              playTimesIndex,
                                              "startTime",
                                              e.target.value
                                            )
                                          }
                                        >
                                          <option value="">Select Hour</option>
                                          {timeChoices.map((timeChoice) => (
                                            <option
                                              key={timeChoice.timeHour}
                                              value={timeChoice.timeHour}
                                            >
                                              {timeChoice.time}
                                            </option>
                                          ))}
                                        </Form.Control>
                                      </Form.Group>
                                    </Col>
                                    <Col
                                      xs={1}
                                      className="pt-2"
                                    >
                                      End:
                                    </Col>
                                    <Col>
                                      <Form.Group controlId="endTime">
                                        <Form.Control
                                          size="sm"
                                          as="select"
                                          value={playTimes.endTime}
                                          onChange={(e) =>
                                            handlePlayDatesFormChange(
                                              index,
                                              playTimesIndex,
                                              "endTime",
                                              e.target.value
                                            )
                                          }
                                        >
                                          <option value="">Select Hour</option>
                                          {timeChoices.map((timeChoice) => (
                                            <option
                                              key={timeChoice.timeHour}
                                              value={timeChoice.timeHour}
                                            >
                                              {timeChoice.time}
                                            </option>
                                          ))}
                                        </Form.Control>
                                      </Form.Group>
                                    </Col>
                                    <Col
                                      sm={1}
                                      className="text-end pt-1 "
                                    >
                                      Plays:
                                    </Col>
                                    <Col sm={2}>
                                      <Form.Group>
                                        <Form.Control
                                          id={"plays"}
                                          size="sm"
                                          type="text"
                                          placeholder="Enter run time"
                                          value={playTimes.plays}
                                          onChange={(event) =>
                                            handlePlaysChange(
                                              index,
                                              playTimesIndex,
                                              event
                                            )
                                          }
                                          maxLength={2}
                                        />
                                      </Form.Group>
                                    </Col>
                                  </Row>
                                )
                              )}
                            </Col>
                          </Row>
                          <Row className="pt-2">
                            <Col className="text-end">
                              <Button
                                size="sm"
                                variant="outline-info"
                                onClick={(event) =>
                                  handleAddTimeButtonClick(event, index)
                                }
                              >
                                Add Time Details
                              </Button>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    ))}
                    <Row className="pt-2">
                      <Col className="text-end">
                        <Button
                          size="sm"
                          variant="outline-info"
                          onClick={handleAddDateButtonClick}
                        >
                          Add Date Details
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row className="p-2 mt-4 text-center  align-items-center">
                  <Col>
                    <Button
                      variant="danger"
                      disabled={isFormDirty}
                      onClick={handleNewAddPromo}
                    >
                      Add A Song
                    </Button>
                  </Col>
                  <Col>
                    <Button
                      variant="primary"
                      disabled={!isFormDirty}
                      type="submit"
                    >
                      Save Changes
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </small>
      </Col>
    </Row>
  );
};
export default AddsPromos;
